import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CloseIcon from "@material-ui/icons/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import { useEffect } from "react";
import { useState } from "react";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { formatDate, showErrorToast } from "../../../../../common/components/Helper/Utils";
import DatePicker from "react-multi-date-picker";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { SpinnerRoundFilled } from "spinners-react";
import { IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { getContactTypeHistory } from "../../actions/contactApi";
import { Link } from "@material-ui/core";

const columns = [
    { id: "invoiceNo", label: "Invoice #", minWidth: 100 },
    {
        id: "invoiceDate",
        label: "Invoice Date",
        minWidth: 100,
    },
    {
        id: "invoiceAmount",
        label: "Invoice Amount",
        minWidth: 100,
    },
    {
        id: "paymentStatus",
        label: "Payment Status",
        minWidth: 100,
    },
    {
        id: "paymentDate",
        label: "Payment Date",
        minWidth: 100,
    },
    {
        id: "balance",
        label: "Balance",
        minWidth: 100,
    },
    {
        id: "invoiceStatus",
        label: "Invoice Status",
        minWidth: 100,
    },
];

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export default function SalesHistoryModal({ open, handleClose, data }) {
    let userData = sessionStorage.getItem("userDetails") ? JSON.parse(sessionStorage.getItem("userDetails")) : null;
    const [rows, setRows] = useState([]);
    const [salesDateValue, setSalesDateValue] = useState([]);
    const [selectedDateValue, setSelectedDateValue] = useState([]);
    const [loader, setLoader] = useState(false);
    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey(prevKey => prevKey + 1);
    }, [selectedDateValue])

    useEffect(() => {
        if (salesDateValue && salesDateValue.length === 2) {
            setSelectedDateValue(salesDateValue);
            getSalesHistoryList(salesDateValue);
        }
        if (
            salesDateValue.length === 0 &&
            selectedDateValue &&
            selectedDateValue.length === 2
        ) {
            setSelectedDateValue([]);
            getSalesHistoryList("clear");
        }
    }, [salesDateValue]);

    useEffect(() => {
        getSalesHistoryList();
    }, [])

    const getSalesHistoryList = (from = null, customPayload = null) => {
        setLoader(true);
        let payload = {
            contactId: data?.contactid || null,
        };
        if (Array.isArray(from) && from?.length > 0) {
            payload["contactInventoryInterval"] = {
                from: from[0].format(),
                to: from[1].format(),
            };
        }
        getContactTypeHistory(payload, (error, response) => {
            if (response && response.status == 1) {
                setRows(response.data);
                setLoader(false);
            } else {
                showErrorToast(response?.message ?? "Something went wrong");
                setLoader(false);
            }
            if (error) {
                showErrorToast(error);
                setLoader(false);
            }
        });
    };

    const handleAfterPrint = React.useCallback(() => {
    }, []);

    const handleOnBeforeGetContent = React.useCallback(() => {
        return Promise.resolve();
    }, []);

    const handleBeforePrint = React.useCallback(() => {
    }, []);

    function CustomInput({ onFocus, value, onChange, label = "Date" }) {
        return (
            <TextField
                id="outlined-basic"
                label={label}
                variant="outlined"
                onClick={onFocus}
                onFocus={onFocus}
                classes={{}}
                style={{ width: "100%" }}
                placeholder="from YYYY/MM/DD to YYYY/MM/DD"
                onPaste={(event) => event.preventDefault()}
                value={value}
                onChange={onChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                    readOnly: true,
                }}
                disabled={false}
                inputProps={{ autoComplete: "off" }}
            />
        );
    }

    const handleNextPage = (data) => {
        let { inventoryid } = data;
        const nextPageUrl = `/inventory-detail/${inventoryid || null}/${userData?.userId || null}`;
        window.open(nextPageUrl, '_blank');
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={"lg"}
            disableEnforceFocus
            PaperProps={{
                style: {
                    minHeight: '450px',
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                Sales History
                <IconButton
                    onClick={() => {
                        handleClose();
                    }}
                    style={{ float: "right" }}
                    className="noprint"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {/* <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                    marginRight: "20px",
                }}
            >
                <ReactToPrint
                    onBeforeGetContent={handleOnBeforeGetContent}
                    onAfterPrint={handleAfterPrint}
                    onBeforePrint={handleBeforePrint}
                    removeAfterPrint
                    trigger={() => (
                        <Button
                            variant="contained"
                            color="primary"
                            className="text-capitalize primary-bg color-white noprint"
                            startIcon={<PrintIcon />}
                        >
                            PRINT
                        </Button>
                    )}
                    content={() => document.getElementById("printable-content")}
                />
            </div> */}
            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginBottom: "20px",
                            marginTop: "20px"
                        }}
                    >
                        <div>
                            <Typography variant="subtitle2">
                                Contact : {(data?.firstname || data?.lastname ? `${data?.firstname || ""} ${data?.lastname || ""}`?.trim() : "")
                                    || data?.businessname
                                    || data?.emailid
                                    || "--"}
                            </Typography>
                            <Typography variant="subtitle2">
                                Last Sales Date: {rows?.lastpurchasedate ? formatDate(rows?.lastpurchasedate) : "-"}
                            </Typography>
                            <Typography variant="subtitle2">
                                Last Sales Amount: {rows?.lastpurchasecost ? Number(rows?.lastpurchasecost) : "-"}
                            </Typography>
                            <Typography variant="subtitle2">
                                Total Open Balance: {"-"}
                            </Typography>
                        </div>
                        <DatePicker
                            key={key}
                            range
                            render={<CustomInput label="Sales Duration" />}
                            value={salesDateValue}
                            containerStyle={{ minWidth: "50%" }}
                            onChange={dateObjects => {
                                setSalesDateValue(dateObjects);
                            }}
                            rangeHover
                            dateSeparator=" to "
                            plugins={[<DatePanel />]}
                        />
                    </div>
                    <TableContainer>
                        <Table aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <StyledTableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows?.data?.length ? (
                                    <>
                                        {rows?.data?.map((row, index) => {
                                            return (
                                                <TableRow hover tabIndex={-1} key={row.code}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                align={column.align}
                                                            >
                                                                {column.id === "inventoryid" ? (value ?
                                                                    <Link component="button" onClick={() => handleNextPage(row)} >
                                                                        <Typography
                                                                            variant="body2"
                                                                            style={{
                                                                                fontSize: "16px", color: "blue", textDecoration: "underline",
                                                                                display: "flex", alignItems: "center"
                                                                            }}
                                                                        >
                                                                            <b>{value ?? "-"}</b>
                                                                        </Typography>
                                                                    </Link> : "-")
                                                                    : column.id === "category" ? (value || "NA")
                                                                        : column.id === "total_cost" ? (value ? Number(value) : "-")
                                                                            : column.id === "purchasedate" && value
                                                                                ? formatDate(value, "MM/DD/YYYY")
                                                                                : value || "-"}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </>
                                ) : (
                                    <TableCell colSpan={12} style={{ textAlign: "center" }}>
                                        <Typography variant="h6" className="color-BCBCBC">
                                            No History Found
                                        </Typography>
                                    </TableCell>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContentText>
            </DialogContent>
        </Dialog >
    );
}